/**
 * Authenticated fetch wrapper that automatically includes JWT token
 * This is a drop-in replacement for the native fetch API
 */
export const authenticatedFetch = async (url, options = {}) => {
  // Get JWT token from localStorage
  const token = localStorage.getItem('auth_token');
  
  // Prepare headers
  const headers = {
    ...options.headers,
  };
  
  // Add Authorization header if token exists
  if (token) {
    headers['Authorization'] = `Bearer ${token}`;
  }
  
  // Merge headers back into options
  const fetchOptions = {
    ...options,
    headers,
  };
  
  // Make the fetch call
  return fetch(url, fetchOptions);
};
